import classNames from "classnames";
import React, { useState } from "react";
import { SiteFooter } from "../SiteFooter";
import { SiteLanguageSuggestion } from "../SiteLanguageSuggestion";
import { SiteNavbar } from "../SiteNavbar";
import styles from "./SiteLayout.scss";

/**
 * Page shell for the public pages: navbar, main content and footer
 * @param fullscreen – cover the whole window (fixed, own scroll), for screens that can render inside the app layout
 * @param hideFooter – leave out the footer, e.g. for focused flows like onboarding
 * @param navbarClassName – extra class on the navbar, e.g. to hide it at some screen sizes
 */
export const SiteLayout = ({ fullscreen, hideFooter, className, navbarClassName, children }) => {
    // In fullscreen mode the overlay scrolls instead of the window, so the navbar needs to watch it
    const [scrollContainer, setScrollContainer] = useState(null);

    const layout = (
        <div className={classNames(styles.base, className)}>
            <SiteLanguageSuggestion />
            <SiteNavbar scrollContainer={scrollContainer} className={navbarClassName} />
            <main className={styles.main}>{children}</main>
            {hideFooter ? null : <SiteFooter />}
        </div>
    );

    return fullscreen ? (
        <div ref={setScrollContainer} className={styles.fullscreen}>
            {layout}
        </div>
    ) : (
        layout
    );
};
